import React, { useState, useRef } from "react";

export default function FileUploader({ backendUrl, benutzer_id, user_token }) {
    const [files, setFiles] = useState([]);
    const [uploading, setUploading] = useState(false);
    const [message, setMessage] = useState("");

    // Upload-History
    const [uploadHistory, setUploadHistory] = useState([]);

    const fileInputRef = useRef(null);
    const dropRef = useRef(null);

    const startUpload = async (uploadFiles) => {
        if (uploadFiles.length === 0) return;

        setUploading(true);
        setMessage("");

        // Dateien eintragen = status "uploading"
        uploadFiles.forEach(file => {
            setUploadHistory(prev => [
                {
                    id: Date.now() + Math.random(),
                    name: file.name,
                    status: "uploading",
                    error: null
                },
                ...prev
            ]);
        });

        const formData = new FormData();
        uploadFiles.forEach((file) => formData.append("documents[]", file));
        formData.append("benutzer_id", benutzer_id);
        formData.append("user_token", user_token);

        try {
            const response = await fetch(
                `${backendUrl}/ajaxController.php?action=uploadDocuments`,
                { method: "POST", body: formData }
            );

            const text = await response.text();
            console.log("RAW RESPONSE TEXT:", text);

            let data = null;
            try {
                data = JSON.parse(text);
                console.log("PARSED JSON:", data);
            } catch (jsonErr) {
                console.error("JSON PARSE ERROR:", jsonErr);
                setMessage("Fehler: Ungültige Server-Antwort.");

                // Fehlerstatus setzen
                uploadFiles.forEach(file => {
                    setUploadHistory(prev =>
                        prev.map(item =>
                            item.name === file.name && item.status === "uploading"
                                ? { ...item, status: "error", error: "Ungültige Server-Antwort" }
                                : item
                        )
                    );
                });

                setUploading(false);
                return;
            }

            const errorCode = parseInt(data.error, 10);

            if (errorCode === 0) {
                setMessage("Vielen Dank! Deine Dateien wurden erfolgreich hochgeladen.");

                // Erfolg-Status setzen
                uploadFiles.forEach(file => {
                    setUploadHistory(prev =>
                        prev.map(item =>
                            item.name === file.name && item.status === "uploading"
                                ? { ...item, status: "success" }
                                : item
                        )
                    );
                });
            } else {
                const errTxt = data.error_text || "Upload fehlgeschlagen.";

                // Fehler-Status setzen
                uploadFiles.forEach(file => {
                    setUploadHistory(prev =>
                        prev.map(item =>
                            item.name === file.name && item.status === "uploading"
                                ? { ...item, status: "error", error: errTxt }
                                : item
                        )
                    );
                });

                setMessage(errTxt);
            }
        } catch (e) {
            console.error("FETCH ERROR:", e);
            setMessage("Fehler beim Upload.");

            // Fehler-Status setzen
            uploadFiles.forEach(file => {
                setUploadHistory(prev =>
                    prev.map(item =>
                        item.name === file.name && item.status === "uploading"
                            ? { ...item, status: "error", error: "Fetch Fehler" }
                            : item
                    )
                );
            });
        }

        setUploading(false);
        setFiles([]);
    };

    const handleFiles = (selectedFiles) => {
        const fileArray = Array.from(selectedFiles);
        setFiles(fileArray);
        startUpload(fileArray);  // ⬅️ Auto-Upload
    };

    const handleFileChange = (e) => {
        handleFiles(e.target.files);
    };

    const handleDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();
        dropRef.current.classList.remove("active");

        if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
            handleFiles(e.dataTransfer.files);
            e.dataTransfer.clearData();
        }
    };

    const handleDragOver = (e) => {
        e.preventDefault();
        dropRef.current.classList.add("active");
    };

    const handleDragLeave = () => {
        dropRef.current.classList.remove("active");
    };

    return (
        <div style={{ marginTop: "40px", textAlign: "center" }}>
            <div
                style={{
                    borderRadius: "15px",
                    padding: "30px",
                    background: "#fafafa",
                    transition: "all 0.2s",
                    maxWidth: "800px",
                    textAlign: "left", // Text innerhalb der Box linksbündig ausrichten
                    display: "flex",   // Flexbox aktivieren
                    alignItems: "center",  // Vertikal ausrichten
                    gap: "15px"        // Abstand zwischen Icon und Text
                }}
            >
                <img
                    src="/info-icon.png"
                    alt="Info Icon"
                    style={{
                        width: "30px",
                        height: "30px",
                        borderRadius: "50%",
                        marginRight: "16px"
                    }}
                />

                <div>
                    <p style={{ fontSize: "14px", fontWeight: "bold", margin: "0px" }}>
                        Wenn du möchtest, kannst du jetzt noch einige Unterlagen hochladen, damit dein Fall schnellstmöglich geprüft werden kann. 
                        Wenn du keine Unterlagen hochladest, hast du später die Möglichkeit diese nachzureichen!<br/><br/>
                    </p>
                    <p style={{ fontSize: "14px", margin: "0px" }}>
                        Hier sind vor allem relevant:<br/>
                        &rarr; Kaufvertrag und Unterlagen zu dem Objekt (oder Entwurf)<br/>
                        &rarr; Nachweis über Einkommen und Eigenmittel (aller Personen)<br/>
                        &rarr; Legitimation bzw. Ausweis (aller Personen)<br/><br/>
                        Der Upload startet automatisch und die Dateien werden zu deiner Anfrage gespeichert.
                    </p>
                </div>
            </div>

            {/* DROPZONE */}
            <div
                ref={dropRef}
                onDragOver={handleDragOver}
                onDragLeave={handleDragLeave}
                onDrop={handleDrop}
                onClick={() => fileInputRef.current.click()}
                style={{
                    border: "2px dashed #bbb",
                    borderRadius: "15px",
                    padding: "30px",
                    background: "#fafafa",
                    transition: "all 0.2s",
                    maxWidth: "500px",
                    margin: "50px auto", // Horizontal zentrieren
                    textAlign: "center"
                }}
                className="dropzone"
            >
                <div style={{ fontSize: "40px", opacity: 0.7 }}>
                    {uploading ? "⏳" : "📁"}
                </div>

                {uploading ? (
                    <p style={{ marginTop: "10px" }}>
                        Upload läuft… bitte warten
                    </p>
                ) : (
                    <p style={{ marginTop: "10px", fontSize: "16px" }}>
                        Dateien hierher ziehen oder antippen
                    </p>
                )}

                <small style={{ opacity: 0.6 }}>
                    PDF oder Bilder
                </small>
            </div>

            {/* HIDDEN FILE INPUT */}
            <input
                type="file"
                multiple
                accept="application/pdf, image/*"
                capture="environment"
                ref={fileInputRef}
                onChange={handleFileChange}
                style={{ display: "none" }}
            />

            {/* SUCCESS / ERROR MESSAGE */}
            {message && (
                <p
                    style={{
                        marginTop: "20px",
                        color: message.startsWith("Vielen") ? "green" : "red",
                        fontWeight: "bold"
                    }}
                >
                    {message}
                </p>
            )}

            {/* --- UPLOAD HISTORY --- */}
            <div style={{ marginTop: "40px", maxWidth: "500px", marginInline: "auto", textAlign: "left", marginBottom: "30px" }}>
                {uploadHistory.map(item => (
                    <div
                        key={item.id}
                        style={{
                            padding: "10px 0",
                            borderBottom: "1px solid #eee",
                            display: "flex",
                            alignItems: "center",
                            gap: "10px"
                        }}
                    >
                        {item.status === "success" && (
                            <span style={{ color: "green", fontSize: "18px" }}>✔</span>
                        )}
                        {item.status === "error" && (
                            <span style={{ color: "red", fontSize: "18px" }}>❌</span>
                        )}
                        {item.status === "uploading" && (
                            <span style={{ fontSize: "18px" }}>⏳</span>
                        )}
                        <span>{item.name}</span>
                    </div>
                ))}
            </div>

            <style>{`
                .dropzone.active {
                    background: #e0ffe0 !important;
                    border-color: green !important;
                    transform: scale(1.02);
                }
            `}</style>
        </div>
    );
}
